import React from 'react';
import * as K from '../constants/constants';

import './ObjectSearchMapLabel.css';

const ObjectSearchMapLabel = (props) => {
  const { cluster, marker, selectedObject, theme } = props;
  let componentName = 'objectsearchmaplabel';
  let themeName = theme === 'bostader' ? '--theme-bostader' : '';
  let bg =
    process.env.NODE_ENV === 'development'
      ? 'http://dios.local.cloudnine.se' + marker.get('image')
      : marker.get('image');

  // render a square label with arrows for multiple objects on same coordinates
  return (
    <div
      className={`${componentName}${themeName} ${cluster ? 'has-cluster' : ''}`}
    >
      <div>
        <a href={marker.get('url')} className={componentName + '-wrapper'}>
          <div className={componentName + '-content'}>
            <div
              className={componentName + '-image'}
              style={{ backgroundImage: `url(${bg}?width=320)` }}
            ></div>

            <div className={componentName + '-title'}>{marker.get('name')}</div>

            <div className={componentName + '-icon-wrapper'}>
              <svg
                className={'svg-icon'}
                width="24"
                height="24"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 26 26"
              >
                <g fill="#03536C" fillRule="nonzero">
                  <path d="M13 0C5.82 0 0 5.82 0 13s5.82 13 13 13 13-5.82 13-13S20.18 0 13 0zm0 24.267C6.778 24.267 1.733 19.222 1.733 13 1.733 6.778 6.778 1.733 13 1.733c6.222 0 11.267 5.045 11.267 11.267A11.267 11.267 0 0113 24.267z" />
                  <path d="M9.351 7.549L14.811 13l-5.46 5.451 1.231 1.231L17.255 13l-6.673-6.682z" />
                </g>
              </svg>
            </div>
          </div>
        </a>
        {cluster ? (
          <div className={componentName + '-controls'}>
            <span className={componentName + '-button'} data-prev-object>
              &#61700;
            </span>
            <span className={componentName + '-info-text'}>
              Visar{' '}
              {cluster.findIndex(
                (marker) => marker.get('id') === selectedObject.id
              ) + 1}{' '}
              av {cluster.size}{' '}
              {props.currentSearchCategory === K.RESIDENCE
                ? 'bostader'
                : 'lokaler'}
            </span>
            <span className={componentName + '-button'} data-next-object>
              &#61701;
            </span>
          </div>
        ) : null}
      </div>
    </div>
  );
};

ObjectSearchMapLabel.propTypes = {};

ObjectSearchMapLabel.defaultProps = {};

export default ObjectSearchMapLabel;



// WEBPACK FOOTER //
// ./src/js/components/ObjectSearchMapLabel.js